/* eslint-disable no-console */
import { isOverlayLayer, matchLayerIdentifier, PrimitiveRole, PrimitiveType, } from "@buildwithflux/models";
import { mat3 } from "../../../common";
export function createPrimitivesForRectangle(node, stackup) {
    const transform = mat3.multiply(
    // TODO: fix - this nullish coalescing is needed due to invalid test data in pcb-layouts directory
    node.bakedRules.transformRelativeToShapesLayer ?? mat3.makeIdentity(), 
    // Apply centering offset to account for start/end being corners, not center
    mat3.makeTranslation(0.5 * node.bakedRules.scale.x * (node.bakedRules.endPosition.x + node.bakedRules.startPosition.x), 0.5 * node.bakedRules.scale.y * (node.bakedRules.endPosition.y + node.bakedRules.startPosition.y)));
    const transformInverse = mat3.invert(transform);
    const layerId = stackup.find((layer) => isOverlayLayer(layer) && matchLayerIdentifier(layer, node.bakedRules.layer))?.uid ??
        null;
    const strokeWidth = node.bakedRules.strokeWidth ?? 0;
    const width = strokeWidth +
        node.bakedRules.scale.x * Math.abs(node.bakedRules.endPosition.x - node.bakedRules.startPosition.x);
    const height = strokeWidth +
        node.bakedRules.scale.y * Math.abs(node.bakedRules.endPosition.y - node.bakedRules.startPosition.y);
    if ((node.bakedRules.cornerRadius?.topLeft ?? 0) > 0 ||
        (node.bakedRules.cornerRadius?.topRight ?? 0) > 0 ||
        (node.bakedRules.cornerRadius?.bottomLeft ?? 0) > 0 ||
        (node.bakedRules.cornerRadius?.bottomRight ?? 0) > 0) {
        return [
            {
                type: PrimitiveType.RoundedRectangle,
                radiusBottomLeft: node.bakedRules.cornerRadius?.bottomLeft ?? 0,
                radiusBottomRight: node.bakedRules.cornerRadius?.bottomRight ?? 0,
                radiusTopLeft: node.bakedRules.cornerRadius?.topLeft ?? 0,
                radiusTopRight: node.bakedRules.cornerRadius?.topRight ?? 0,
                width,
                height,
                transform,
                transformInverse,
                layerId,
                role: PrimitiveRole.silkScreen,
            },
        ];
    }
    else {
        return [
            {
                type: PrimitiveType.Rectangle,
                width,
                height,
                transform,
                transformInverse,
                layerId,
                role: PrimitiveRole.silkScreen,
            },
        ];
    }
}
//# sourceMappingURL=createPrimitivesForRectangle.js.map